export function validationStatusRenderer(params: { value?: boolean | null }) {
  if (params.value === null) {
    return '';
  }

  if (params.value === true) {
    return '<span class="fa fa-check" style="color: #4caf50;" title="Validated"></span>';
  }
  return '<span class="fa fa-user" style="color: #ff9800;" title="Needs validation"></span>';
}
